import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "../lib/api";
import { useT } from "../i18n/LanguageContext";

export const LabSection = () => {
  const { t } = useT();
  const x = t.lab;
  return (
    <section className="relative overflow-hidden" data-testid="lab-section">
      <div className="absolute inset-0">
        <img src={ASSETS.attimosphere1} alt="" className="w-full h-full object-cover kenburns opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-b from-[var(--pn-black)] via-[var(--pn-black)]/65 to-[var(--pn-black)]" />
      </div>

      <div className="relative section-pad section-pad-top-tight max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <motion.span
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
              transition={{ duration: 0.8 }} className="eyebrow"
            >
              {x.eyebrow}
            </motion.span>
            <motion.h2
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 1.1, ease: [0.22, 0.61, 0.36, 1] }}
              className="mt-5 font-display font-light text-[40px] sm:text-[56px] md:text-[80px] lg:text-[100px] leading-[0.98] tracking-[-0.02em] text-[var(--pn-milk)]"
            >
              {x.title_a}
              <br />
              <em className="italic text-[var(--pn-amber)]">{x.title_b}</em>
            </motion.h2>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ delay: 0.25, duration: 1 }}
            className="lg:col-span-5 lg:pl-8 lg:border-l lg:border-[var(--pn-amber)]/20"
          >
            <p className="text-[16px] md:text-[18px] leading-[1.75] text-[var(--pn-cream)]/85 font-light">
              {x.p1_a}
              <span className="italic font-display text-[var(--pn-amber)]">{x.p1_b}</span>
              {x.p1_c}
            </p>
            <p className="mt-5 text-[15px] md:text-[17px] leading-[1.8] text-[var(--pn-cream)]/65 font-light">
              {x.p2}
            </p>
            <p className="mt-5 font-display italic text-[18px] md:text-[20px] text-[var(--pn-milk)]/90 leading-[1.5]">
              {x.pull_a}
              <br />
              {x.pull_b}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
